var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourceReports = function SvgResourceReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 12v3.75M12 10.98v4.77M15 7.992v7.758M16.5 2.25l-6.485 6.485a.375.375 0 0 1-.531 0l-2.47-2.47a.375.375 0 0 0-.53 0L1.5 11.25M3 13.847v1.903M6 10.993v4.758"
  })));
};
export default SvgResourceReports;